import { EcommStoreProductPageEnhancedCF } from '@/contentful/api/types';
import {
  BlogCategoryPageContentType,
  BlogPageContent,
  SocialSites,
  StandardPageContent,
} from '@/contentful/types';
import { DynamicRedirectPageCF } from '@/types';

export const generateSocialLinkShare = (
  socialType: SocialSites,
  url: string,
  title?: string
) => {
  if (socialType === SocialSites.FACEBOOK) {
    return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  } else if (socialType === SocialSites.LINKEDIN) {
    return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
  } else if (socialType === SocialSites.TWITTER) {
    return `https://twitter.com/intent/tweet?${
      title ? `text=${encodeURI(title)}&` : ''
    }url=${url}`;
  }
};

const AVERAGE_READING_SPEED_WPM = 238;

export function getAverageReadTimeMinutes(text: string) {
  return Math.round(text.split(' ').length / AVERAGE_READING_SPEED_WPM) || 1;
}

type AllType =
  | StandardPageContent
  | BlogPageContent
  | BlogCategoryPageContentType
  | DynamicRedirectPageCF
  | EcommStoreProductPageEnhancedCF;

export const isBlogCategoryType = (
  pageContent: AllType
): pageContent is BlogCategoryPageContentType => {
  return (
    (pageContent as BlogCategoryPageContentType).fields.linkedArticleContent !==
    undefined
  );
};
